<div class="app-payment-section app-mobile-payment" id="paymentSection" fxLayout="column">
    <div [hidden]="!activatedRoute.snapshot.queryParams.language">
        <app-google-translate></app-google-translate>
    </div>
    <div *ngIf="showOverlay" class="p-msg">
        <span class="p-msg-disp primary-bg-font-color2">Please do not refresh the page while we are
            processing your payment
            {{timer}}</span>
    </div>
    <div fxFlex="100%" *ngIf="!redirectUrl">
        <a class="logo pointer" class="logo"><img class="p-10" height="60" [src]="clientDetails.header_logo"></a>
    </div>
    <!-- <div fxLayout="row" class="menu-header w-100" *ngIf="paymentType == 'performer_tip'" fxShow fxHide.xs="true">
        <div fxFlex="80%">
            <h6 class="fs-16 ff fw-500">Tips</h6>
        </div>
        <div fxFlex="20%" class="text-right lh-19" (click)="closeMenu()">
            <img src="assets/Live-Stream-assets/close-icon-white.svg">
         </div>
    </div>  -->

    <div *ngIf="!isPaymentSuccess && !paymentSuccess" class="p-20 mr-5" fxLayout="column">
        <!-- <div fxLayout="row wrap"  class="payment-detail display"> -->
        <div class="fs-20 fw-500 " [ngStyle]="{'color':settingsData?.form_font_secondary_color}">
            ORDER DETAILS <span class="amount float-right  pl-20">{{finalAmount | currency:currency}}</span>
        </div>

        <!-- <div class="amount   pl-20"> -->
        <div *ngIf="selectedTransaction == 'crypto'">
            <!-- {{finalAmount | currency:currency}} -->
            <span matTooltip="{{crypto_amount}}" class="fs-17 cryptoValue">(<img src="{{cryptoSymbol}}" width="17px"
                    class="mb-1 mr-1" />{{sliced_crypto_amount}}...{{cryptoToken}})</span>


        </div>
        <div fxLayout="row wrap" fxFlex="100%" class="plan-details ptb-15 fs-14" fxLayoutAlign="start start">
            <ng-container *ngIf="paymentType == 'charity_donation'">
                <span class="headings w-50">Charity Name</span>
                <span class="w-50  txt-captialize">
                    <span *ngIf="charityInfo?.charity_name?.length < 12">
                        : {{charityInfo?.charity_name}}
                        <!-- <span (click)="toggleDescription()" class=" pl-5" role="button" aria-expanded="false" aria-controls="collapseExample">
                            <i class="fa fa-angle-down" aria-hidden="true" *ngIf="!showDescription"></i>
                            <i class="fa fa-angle-up" aria-hidden="true" *ngIf="showDescription"></i>
                        </span> -->
                    </span>
                    <span *ngIf="charityInfo?.charity_name?.length >= 12" matTooltipPosition="above"
                        matTooltip="{{charityInfo?.charity_name}}">
                        : {{charityInfo?.charity_name |limitTo:12}}...
                        <!-- <span (click)="toggleDescription()" class=" pl-5" role="button" aria-expanded="false" aria-controls="collapseExample">
                            <i class="fa fa-angle-down" aria-hidden="true" *ngIf="!showDescription"></i>
                            <i class="fa fa-angle-up" aria-hidden="true" *ngIf="showDescription"></i>
                        </span> -->
                    </span>
                </span>
                <!-- <div *ngIf="showDescription">
                    <span class="headings w-50 ptb-1 pr-10">Charity Description</span>
                <span class=" w-50" *ngIf="charityInfo?.charity_description">
                    : {{charityInfo?.charity_description}}</span>
                  </div> -->
                <span class="headings w-50 ptb-1">Charity Description</span>
                <span class=" w-50 txt-captialize" *ngIf="charityInfo?.charity_description?.length < 12">
                    : {{charityInfo?.charity_description}}</span>
                <span class=" w-50 txt-captialize" *ngIf="charityInfo?.charity_description?.length >= 12">
                    : {{charityInfo?.charity_description|limitTo:12}}...<span class="more-txt pointer"
                        (click)="alterDescriptionText()">
                        {{ showShortDesciption ? 'Less': 'More' }}
                    </span></span>
                <span class="headings w-50 ptb-1" *ngIf="showShortDesciption"></span>
                <span class="ptb-5 w-50  pl-5 txt-captialize" *ngIf="showShortDesciption">
                    {{charityInfo?.charity_description}}
                </span>
                <!-- <button type="button" (click)="alterDescriptionText()">
                        {{ showShortDesciption ? 'SHOW ALL': 'SHOW LESS' }}
                        </button> -->
                <!-- <span class="headings w-50">Organization Name</span>
                <span class="w-50 ">: {{charityInfo?.organization_name}}</span>
                <span class="headings w-50">Performer Name</span>
                <span class="w-50 ">: {{performerInfo?.performer_name}}</span> -->
                <span class="headings w-31" [ngStyle]="{'color':settingsData?.form_font_secondary_color}">Type of Order</span>
                <span class="w-50 ">: Charity Donation</span>
            </ng-container>
            <ng-container *ngIf="paymentType == 'performer_tip' || paymentType == 'community_tip'">
                <!-- <span class="headings w-50">Organization Name</span>
                <span class=" w-50">: {{performerInfo?.organization_name}}</span>
                <span class="headings w-50">Performer Name</span>
                <span class="w-50 ">: {{performerInfo?.performer_name}}</span> -->
                <span class="headings w-31" [ngStyle]="{'color':settingsData?.form_font_secondary_color}">Type of Order</span>
                <span class="w-50 " [ngStyle]="{'color':settingsData?.form_font_secondary_color}">: Performer Tip</span>
            </ng-container>
            <ng-container *ngIf="paymentType == 'pay_per_view'" class="">
                {{streamInfo?.stream_video_title}} - Pay Per View
            </ng-container>
        </div>
        <!-- </div> -->
        <!-- <mat-tab-group (selectedTabChange)="getActiveTabData($event)">
            <mat-tab label="Credit Card"> -->

        <div fxLayout="row wrap" fxFlex="100%" *ngIf="!isEnteredOtherUser">
            <div fxFlex="100%" class="mb-10">
                Users Information
            </div>

            <form [formGroup]="contactInfoForm">

                <ng-container *ngIf="contactList.controls && contactList.controls.length > 0">

                    <div fxFlex="100%" fxLayout="row wrap" formArrayName="contactList">
                        <ng-container *ngFor="let array of contactList.controls;let i = index;">
                            <div fxFlex="100%" fxLayout="row wrap" [formGroupName]="i" fxLayoutGap="15px grid"
                                fxLayoutAlign="start center" class="other-user-info">
                                <div fxFlex="33.3%" fxFlex.xs="100%">
                                    <mat-form-field class="w-100">
                                        <mat-label>First Name</mat-label>
                                        <input class="fs-16" matInput placeholder="" formControlName="user_first_name"
                                            required>
                                        <mat-error
                                            *ngIf="contactList.controls[i].get('user_first_name').hasError('required')">
                                            Please enter first name
                                        </mat-error>
                                    </mat-form-field>
                                </div>
                                <div fxFlex="33.3%" fxFlex.xs="100%">
                                    <mat-form-field class="w-100">
                                        <mat-label>Last Name</mat-label>
                                        <input class="fs-16" matInput placeholder="" formControlName="user_last_name"
                                            required>
                                        <mat-error
                                            *ngIf="contactList.controls[i].get('user_last_name').hasError('required')">
                                            Please enter last name
                                        </mat-error>
                                    </mat-form-field>
                                </div>
                                <div fxFlex="33.3%" fxFlex.xs="100%">
                                    <mat-form-field class="w-100">
                                        <mat-label>Email</mat-label>
                                        <input matInput placeholder="" formControlName="user_email"
                                            (focusout)="setUniqueEmail(i)" required>
                                        <mat-error
                                            *ngIf="contactList.controls[i].get('user_email').hasError('required')">
                                            Please enter email
                                        </mat-error>
                                        <mat-error *ngIf="contactList.controls[i].get('user_email').hasError('email')">
                                            Please enter valid email
                                        </mat-error>
                                    </mat-form-field>
                                </div>
                            </div>
                        </ng-container>
                        <div fxFlex="100%" class="mt-30 mb-100 text-center">
                            <button mat-flat-button class="flat-primary-button"
                                (click)="saveOtherUserTicket()">Continue</button>
                        </div>
                    </div>

                </ng-container>
            </form>

        </div>

        <div id="address-block" [hidden]="showCCForm || !isEnteredOtherUser">
            <div fxLayout="column">
                <ng-container *ngIf="showShippingForm">
                    <div fxFlex="100%">
                        <h6 class="sub-heading pt-20">Shipping Address</h6>
                    </div>
                    <form class="display-block" [formGroup]="shippingForm">
                        <div fxLayout="row wrap" fxLayout.xs="column" fxLayoutGap="15px grid">
                            <div fxFlex="100%">
                                <mat-form-field class="w-100">
                                    <mat-label>Country</mat-label>
                                    <input matInput placeholder="" name="Country" [matAutocomplete]="auto"
                                        (input)="filterCountry()" formControlName="country" required>
                                    <mat-autocomplete #auto="matAutocomplete" [displayWith]="displayCountryName"
                                        (optionSelected)="selectCountry($event.option,'shippingForm');">
                                        <mat-option *ngFor="let country of countriesList;" [value]="country">
                                            <span>{{country.name}}</span>
                                        </mat-option>
                                    </mat-autocomplete>
                                    <mat-error *ngIf="shippingForm.get('country').hasError('required')">
                                        Please select country
                                    </mat-error>
                                    <mat-error *ngIf="!shippingForm.get('country').hasError('required') && 
                                    shippingForm.get('country').hasError('mat-require-match')">
                                        Please select country from existing list
                                    </mat-error>
                                </mat-form-field>
                            </div>
                            <div fxFlex="100%">
                                <mat-form-field class="w-100" *ngIf="countryChanged">
                                    <mat-label>
                                        <span *ngIf="shippingCountry.name != 'United Kingdom'">Address line 1</span>
                                        <span *ngIf="shippingCountry.name == 'United Kingdom'">Address</span>
                                    </mat-label>
                                    <input matInput placeholder="" formControlName="address1" ngx-gp-autocomplete
                                        [options]="options"
                                        (onAddressChange)="getSelectedAddress($event,'shippingForm')"
                                        (paste)="onPasteLocation($event)" required />
                                    <mat-error *ngIf="shippingForm.get('address1').hasError('required')">
                                        Please enter address
                                    </mat-error>
                                </mat-form-field>
                                <!-- <span class="fs-11">Note: Please select your address from auto populated list</span> -->
                            </div>
                            <div fxFlex="100%" *ngIf="shippingCountry.name != 'United Kingdom'">
                                <mat-form-field class="w-100">
                                    <mat-label><span>Address line 2</span></mat-label>
                                    <input matInput placeholder="" autocomplete="disabled" formControlName="address2">
                                </mat-form-field>
                            </div>
                            <div fxFlex="100%">
                                <mat-form-field class="w-100">
                                    <mat-label><span>City</span></mat-label>
                                    <input matInput placeholder="" formControlName="city" required>
                                    <mat-error *ngIf="shippingForm.get('city').hasError('required')">
                                        Please enter city
                                    </mat-error>
                                </mat-form-field>
                            </div>
                            <div fxFlex="100%" *ngIf="shippingCountry.stateless != 'yes'">
                                <mat-form-field class="w-100">
                                    <mat-label><span>State</span></mat-label>
                                    <input matInput placeholder="" formControlName="state" required>
                                    <mat-error *ngIf="shippingForm.get('state').hasError('required')">
                                        Please enter state
                                    </mat-error>
                                </mat-form-field>
                            </div>
                            <div fxFlex="100%">
                                <mat-form-field class="w-100" *ngIf="shippingCountry.name != 'United Kingdom'">
                                    <mat-label><span>Zip code</span></mat-label>
                                    <input matInput placeholder="" formControlName="zip" required>
                                    <mat-error *ngIf="shippingForm.get('zip').hasError('required')">
                                        <span>Please enter zip code</span>
                                    </mat-error>
                                </mat-form-field>
                                <mat-form-field class="w-100" *ngIf="shippingCountry.name == 'United Kingdom'">
                                    <mat-label><span>Postal code</span></mat-label>
                                    <input matInput placeholder="" formControlName="zip" required>
                                    <mat-error *ngIf="shippingForm.get('zip').hasError('required')">
                                        <span>Please enter postal code</span>
                                    </mat-error>
                                </mat-form-field>
                            </div>
                        </div>
                    </form>
                    <mat-checkbox name="addressval" class="fw-300 text-white app-primary-bg"
                        [ngClass]="{'slick-disabled':shippingForm.invalid}" [disabled]="shippingForm.invalid"
                        (change)="populateBillingAddress($event)">
                        Same as shipping address
                    </mat-checkbox>
                    <h6 class="sub-heading pt-20">Billing Address</h6>
                </ng-container>
                <div fxFlex="100%" class="pt-15 community-tip-popup" *ngIf="athletesData && athletesData?.length > 0 && isFromCommunityTips">
                    <mat-form-field class="w-100" [style.--form-border-color]="settingsData?.form_font_secondary_color" [style.--before-border-color]="settingsData?.form_font_secondary_color">
                        <mat-label [ngStyle]="{'color': settingsData?.form_font_secondary_color}">Sports Personnel</mat-label>
                        <mat-select [formControl]="athleteControl" (selectionChange)="selectAthlete($event);" required [style.--select-value-text]="settingsData?.form_font_secondary_color">
                            <mat-option *ngFor="let athlete of athletesData;" [value]="athlete" [style.background-color]="settingsData?.bg_tertiary_color + '!important'" [style.color]="settingsData?.font_tertiary_color +'!important'">
                                <span>{{ athlete.personalInfo?.firstName }} {{ athlete.personalInfo?.lastName }}</span>
                            </mat-option>
                        </mat-select>
                        <mat-error *ngIf="athleteControl.invalid && athleteControl.touched  && paymentAreaClicked">
                            Please sports personnel
                        </mat-error>
                    </mat-form-field>
                </div>
                <div fxFlex="100%" class="community-tip-popup">
                    <mat-form-field class="w-100" [style.--form-border-color]="settingsData?.form_font_secondary_color" [style.--before-border-color]="settingsData?.form_font_secondary_color">
                        <mat-label [ngStyle]="{'color': settingsData?.form_font_secondary_color}">Currency</mat-label>
                        <mat-select [(ngModel)]="currencyVal" [ngModelOptions]="{standalone: true}" [style.--select-value-text]="settingsData?.form_font_secondary_color"
                            (selectionChange)="changeCurrency($event)" required>
                            <mat-option [value]="currency" *ngFor="let currency of currenciesList" [style.background-color]="settingsData?.bg_tertiary_color + '!important'" [style.color]="settingsData?.font_tertiary_color +'!important'">
                                {{currency}}
                            </mat-option>
                        </mat-select>
                    </mat-form-field>
                </div>
                <form class="display-block mt-15" [formGroup]="billingForm" autocomplete="off">
                    <div fxLayout="row wrap" fxLayout.xs="column">

                        <div fxFlex="100%" fxLayout="row" class="amount-field tips-amount pb-10 pr-0"
                            *ngIf="paymentType !='pay_per_view' && ['USD', 'INR', 'GBP', 'EUR', 'JPY'].includes(currency)">
                            <h6 class="ff fs-16 mt-10 mr-0" fxFlex="55%" fxFlex.xs="55%" [ngStyle]="{'color':settingsData?.form_font_secondary_color}"
                                *ngIf="paymentType !='pay_per_view' && (paymentType == 'performer_tip' || paymentType == 'community_tip')">
                                Enter your tip*
                            </h6>
                            <h6 class="ff fs-16 mt-10 mr-0" fxFlex="55%" fxFlex.xs="65%" [ngStyle]="{'color':settingsData?.form_font_secondary_color}"
                                *ngIf="paymentType !='pay_per_view' && paymentType == 'charity_donation'">Enter your
                                donation</h6>
                            
                            <mat-form-field class="w-120 relative "  [style.--form-border-color]="settingsData?.form_font_secondary_color" [style.--before-border-color]="settingsData?.form_font_secondary_color"
                                *ngIf="paymentType == 'performer_tip' || paymentType == 'charity_donation' || paymentType == 'community_tip'">
                                <!-- <div *ngIf="paymentType == 'performer_tip'" class="absolute">
                                    <label *ngIf="currency == 'USD'">$</label>
                                    <label *ngIf="currency == 'GBP'">£</label>
                                </div>-->
                                <div>
                                    <label class="secondary-bg-font-color1" [style.color]="settingsData?.form_font_secondary_color +'!important'">{{ currency|currencySymbol }}</label>
                                </div>
                                <input matInput allowValues autofocus="autofocus" isInputType="number"
                                    isInputType="decimalWithTwoDigits" min="0" step="1" class="amount-txt"
                                    (ngModelChange)="checkAmount($event)" (blur)="amountChange($event.target.value)"
                                    formControlName="amount" [style.color]="settingsData?.form_font_secondary_color +'!important'" required>
                                <!-- <input matInput allowValues autofocus="autofocus" *ngIf="allowDecimals"
                                    isInputType="number" isInputType="decimalWithTwoDigits" min="0" step="1" (ngModelChange)="checkAmount($event)"
                                    class="amount-txt" (blur)="amountChange($event.target.value)"
                                    formControlName="amount" required> -->
                                <mat-error *ngIf="billingForm?.get('amount')?.hasError('required') && paymentAreaClicked">
                                    Please enter amount
                                </mat-error>
                                
                            </mat-form-field>
                        </div>
                        <h6 class="ff fs-16 mt-10 mr-0" fxFlex="55%" fxFlex.xs="55%" *ngIf="conversionRate && channelDetails?.recommendedTips">
                            Recommended Tips
                        </h6>
                        <div class="row text-center gx-5 mb-20" *ngIf="conversionRate && channelDetails?.recommendedTips">                            
                            <div class="col-sm-3 col-3 mt-20" *ngFor="let tip of channelDetails?.recommendedTips | slice:0:4">
                                <button mat-flat-button class="btn-margin" [ngClass]="{'selected-amt':selectedTip == tip.value * conversionRate}" (click)="applyTip(tip.value)"
                                [ngStyle]="selectedTip == tip.value * conversionRate
                                ? {'background-color': settingsData?.bg_tertiary_color,
                                'color': settingsData?.font_tertiary_color}
                                : {}">{{tip.value * conversionRate  | currency : currency}}</button>
                            </div>
                        </div>

                        <span fxFlex="100%" *ngIf="!['USD', 'INR', 'GBP', 'EUR', 'JPY'].includes(currency)" class="disable-note">Transactions for the {{currency}} currency are temporarily unavailable</span><br>
                        <span fxFlex="100%" *ngIf="['USD', 'INR', 'GBP', 'EUR', 'JPY'].includes(currency)" [ngStyle]="{'color':settingsData?.form_font_secondary_color}">Minimum required amount is {{minAmount | currency : currency}}</span><br>

                        <div fxFlex="100%" *ngIf="paymentType =='pay_per_view'">
                            <mat-form-field class="w-100">
                                <mat-label><span>Amount</span></mat-label>
                                <input matInput placeholder="" allowValues isInputType="decimalWithTwoDigits"
                                    (input)="amountChange($event.target.value)" formControlName="amount" required>
                                <mat-error *ngIf="billingForm?.get('amount').hasError('required')">
                                    Please enter amount
                                </mat-error>
                            </mat-form-field>
                        </div>
                        <div fxLayout="row wrap"
                            *ngIf="(settingsJSON?.fee_to_fan == 1 || selectedTransaction == 'ott') && processingFee && getBillingValue?.amount">
                            <div fxFlex="100%" class="mb-5 fw-600 mt-20">Summary</div>
                            <div fxLayoutAlign="start center" fxFlex="50%">Items
                                <!-- <span *ngIf="incl" style="font-size: 12px;margin-left: 5px;margin-top: 5px;"> (Incl. VAT)</span> -->
                            </div>
                            <div fxLayoutAlign="end center" fxFlex="50%">
                                {{billingForm?.get('amount').value | currency:currency}}</div>
                            <div fxLayoutAlign="start center" fxFlex="50%" *ngIf="!incl && taxAmount > 0">Estimated Tax
                            </div>
                            <div *ngIf="!incl && taxAmount > 0" fxLayoutAlign="end center" fxFlex="50%">
                                {{taxAmount | currency:currency}}
                            </div>
                            <div fxLayoutAlign="start center" fxFlex="50%"
                                *ngIf="settingsJSON?.fee_to_fan == 1 && processingFee && (!selectedTransaction || selectedTransaction =='ott')">
                                Processing Fee
                            </div>
                            <div *ngIf="settingsJSON?.fee_to_fan == 1 && processingFee && (!selectedTransaction || selectedTransaction =='ott')"
                                fxLayoutAlign="end center" fxFlex="50%">
                                {{processingFee | currency:currency}}
                            </div>
                            <div fxLayoutAlign="start center" fxFlex="50%" class="mt-10 pt-10 fs-20 total-row">Total
                            </div>
                            <div fxLayoutAlign="end center" fxFlex="50%"
                                class="amount notranslate mt-10 pt-10 fs-20 total-row">
                                {{finalAmount | currency:currency}}</div>
                        </div>
                        <div class="radio-btn w-100">
                            <div [hidden]="!userInfo?.id" (click)="onPaymentAreaClick()" *ngIf="['USD', 'INR', 'GBP', 'EUR', 'JPY'].includes(currency)">
                                <!-- <app-default-address></app-default-address> -->
                                <app-payment-transactions (getTransactionDetails)="calFee($event)"
                                    [activeBlock]="activeBlock" [settingsData]="settingsData"></app-payment-transactions>

                            </div>
                        </div>
                        <ng-container *ngIf="showBillingForm">
                            <div fxFlex="100%">
                                <!-- <mat-form-field class="w-100">
                                <input matInput placeholder="Country" formControlName="country" required>
                                <mat-error *ngIf="billingForm.get('country').hasError('required')">
                                    Please enter country
                                </mat-error>
                            </mat-form-field> -->
                                <!-- <mat-form-field class="w-100">
                                <mat-label>Country</mat-label>
                                <mat-select formControlName="country" (selectionChange)="selectCountry($event)" required>                                                                           
                                    <mat-option *ngFor="let country of countriesList" [value]="country">
                                        {{country.name}}</mat-option>
                                </mat-select>
                                <mat-error *ngIf="billingForm.get('country').hasError('required')">
                                    Please select country
                                </mat-error>
                            </mat-form-field> -->
                                <mat-form-field class="w-100">
                                    <mat-label>Country</mat-label>
                                    <input matInput placeholder="" name="Country" [matAutocomplete]="auto"
                                        (input)="filterCountry()" formControlName="country" (blur)="setCountry($event)"
                                        required>
                                    <mat-autocomplete #auto="matAutocomplete" [displayWith]="displayCountryName"
                                        (optionSelected)="selectCountry($event.option,'billingForm');">
                                        <mat-option *ngFor="let country of countriesList;" [value]="country">
                                            <span>{{country.name}}</span>
                                        </mat-option>
                                    </mat-autocomplete>
                                    <mat-error *ngIf="billingForm?.get('country').hasError('required')">
                                        Please select country
                                    </mat-error>
                                    <mat-error *ngIf="!billingForm?.get('country').hasError('required') && 
                                billingForm?.get('country').hasError('mat-require-match')">
                                        Please select country from existing list
                                    </mat-error>
                                </mat-form-field>
                            </div>
                            <div fxFlex="100%">
                                <mat-form-field class="w-100" *ngIf="countryChanged">
                                    <mat-label><span *ngIf="billingCountry.name != 'United Kingdom'">Address line
                                            1</span><span *ngIf="billingCountry.name == 'United Kingdom'">Address</span>
                                    </mat-label>
                                    <input matInput placeholder="" formControlName="address1" ngx-gp-autocomplete
                                        [options]="options"
                                        (onAddressChange)="getSelectedAddress($event, 'billingForm')"
                                        (paste)="onPasteLocation($event,'billingForm')" required />
                                    <mat-error *ngIf="billingForm?.get('address1').hasError('required')">
                                        Please enter address
                                    </mat-error>
                                </mat-form-field>
                                <!-- <span class="fs-11">Note: Please select your address from auto populated list</span> -->
                            </div>
                            <div fxFlex="100%" *ngIf="billingCountry.name != 'United Kingdom'">
                                <mat-form-field class="w-100">
                                    <mat-label><span>Address line 2</span></mat-label>
                                    <input matInput placeholder="" autocomplete="disabled" formControlName="address2">
                                </mat-form-field>
                            </div>
                            <div fxFlex="100%">
                                <mat-form-field class="w-100">
                                    <mat-label><span>City</span></mat-label>
                                    <input matInput placeholder="" formControlName="city" required>
                                    <mat-error *ngIf="billingForm?.get('city').hasError('required')">
                                        Please enter city
                                    </mat-error>
                                </mat-form-field>
                            </div>
                            <div fxFlex="100%" *ngIf="billingCountry.name != 'United Kingdom'">
                                <mat-form-field class="w-100">
                                    <mat-label><span>State</span></mat-label>
                                    <input matInput placeholder="" formControlName="state" required>
                                    <mat-error *ngIf="billingForm?.get('state').hasError('required')">
                                        Please enter state
                                    </mat-error>
                                </mat-form-field>
                            </div>
                            <!-- <div fxFlex="100%">
                            <mat-form-field class="w-100">
                                <input matInput placeholder="Country" formControlName="country" required>
                                <mat-error *ngIf="billingForm.get('country').hasError('required')">
                                    Please enter country
                                </mat-error>
                            </mat-form-field>
                        </div> -->
                            <div fxFlex="100%">

                                <mat-form-field class="w-100" *ngIf="billingCountry.name != 'United Kingdom'">
                                    <mat-label><span>Zip code</span></mat-label>
                                    <input matInput placeholder="" formControlName="zip" required>
                                    <mat-error *ngIf="billingForm?.get('zip').hasError('required')">
                                        <span>Please enter zip code</span>
                                    </mat-error>
                                </mat-form-field>
                                <mat-form-field class="w-100" *ngIf="billingCountry.name == 'United Kingdom'">
                                    <mat-label><span>Postal code</span></mat-label>
                                    <input matInput placeholder="" formControlName="zip" required>
                                    <mat-error *ngIf="billingForm?.get('zip').hasError('required')">
                                        <span>Please enter postal code</span>
                                    </mat-error>
                                </mat-form-field>

                            </div>
                            <div fxFlex="100%" class="mt-20 app-ticket"
                                *ngIf="!redirectUrl && paymentType =='pay_per_view'">
                                <mat-checkbox name="isAgrees" class="fw-300" [ngModelOptions]="{standalone: true}"
                                    (change)="openEventTermsConditions(isAgrees)" [(ngModel)]="isAgrees">
                                    I agree to the event terms and conditions.
                                </mat-checkbox>
                            </div>
                        </ng-container>
                        <div fxFlex="100%" class="text-center pr-0 mtb-20">
                            <!-- <button mat-flat-button class="flat-primary-button" id="proceed-button"
                                (click)="proceed()">Proceed</button> -->
                            <!-- <button fxShow.xs="true" fxHide mat-flat-button class="square-btn bgc-grey ml-20"
                                        (click)="redirectToHome()">Cancel</button> -->
                            <!-- <button mat-flat-button fxHide.xs="true" *ngIf="deviceData == 'web'" fxShow
                                class="flat-secondary-button ml-20" (click)="close(paymentType)">Cancel</button> -->
                        </div>
                    </div>
                </form>
            </div>
        </div>
        <div id="card-block" [hidden]="!showCCForm">
            <div class="display-block w-100">
                <div fxLayout="row wrap">
                    <div class="mb-15 fw-600 w-100">Billing Address</div>

                    <div *ngIf="billingForm?.get('address1').value && !selectedCard?.id">
                        <i class="material-icons fs-13"> room </i>
                        {{billingForm?.get('address1').value}},

                        <span
                            *ngIf="billingForm?.get('address2').value">{{billingForm.get('address2').value}},</span><br>
                        {{billingForm?.get('city').value}}, {{billingForm?.get('state').value}},<br>
                        {{billingForm?.get('country').value?.name}}, {{billingForm?.get('zip').value}}<br>
                        <span (click)="showCCForm = false" class="edit pointer fw-600">Edit</span>
                    </div>
                    <div *ngIf="selectedBillingAddress && selectedBillingAddress.line1">
                        <i class="material-icons fs-13"> room </i>
                        {{selectedBillingAddress.line1}}, <span
                            *ngIf="selectedBillingAddress.line2">{{selectedBillingAddress.line2}},</span><br>
                        {{selectedBillingAddress.city}}, {{selectedBillingAddress.state}},<br>
                        {{selectedBillingAddress.country}}, {{selectedBillingAddress.zip}}<br>
                        <span (click)="showCCForm = false" class="edit pointer fw-600">Edit</span>
                    </div>
                </div>
                <div fxLayout="row wrap" *ngIf="taxable">
                    <div fxFlex="100%" class="mb-5 fw-600 mt-20">Summary</div>
                    <div fxLayoutAlign="start center" fxFlex="50%">Items
                        <!-- <span *ngIf="incl" style="font-size: 12px;margin-left: 5px;margin-top: 5px;"> (Incl. VAT)</span> -->
                    </div>
                    <div fxLayoutAlign="end center" fxFlex="50%">
                        {{billingForm?.get('amount').value | currency:currency}}</div>
                    <div fxLayoutAlign="start center" fxFlex="50%" *ngIf="!incl && taxAmount > 0">Estimated Tax</div>
                    <div *ngIf="!incl && taxAmount > 0" fxLayoutAlign="end center" fxFlex="50%">
                        {{taxAmount | currency:currency}}
                    </div>
                    <div fxLayoutAlign="start center" fxFlex="50%" *ngIf="settingsJSON?.fee_to_fan == 1">Processing Fee
                    </div>
                    <div *ngIf="settingsJSON?.fee_to_fan == 1" fxLayoutAlign="end center" fxFlex="50%">
                        {{processingFee | currency:currency}}
                    </div>
                    <div fxLayoutAlign="start center" fxFlex="50%" class="mt-10 pt-10 fs-20 total-row">Total</div>
                    <div fxLayoutAlign="end center" fxFlex="50%" class="amount notranslate mt-10 pt-10 fs-20 total-row">
                        {{finalAmount | currency:currency}}</div>
                </div>

                <!-- 19-10-2021 disabled paystand -->
                <div *ngIf="false && getCurrency == 'USD'" fxFlex="100%" class="mt-30">
                    <div id="ps_checkout_load">
                    </div>

                    <div *ngIf="!reopen" id="ps_container_id" class="mb-20"></div>
                    <div *ngIf="reopen" id="ps_container_id" class="mb-20">
                        <div class="ps-checkout ps-checkout-visible ps-mode-embed">
                            <div class="ps-checkout-inner">
                                <div class="ps-checkout-content" style="height: 320px; width: 300px;"><iframe
                                        id="paystand_checkout_iframe" width="100%" height="100%" frameborder="0"
                                        [src]="psSrc | safe:'resourceUrl'"></iframe></div>
                            </div>
                        </div>
                    </div>
                    <button mat-flat-button fxHide.xs="true" fxShow class="flat-secondary-button"
                        (click)="close(paymentType)">Cancel</button>
                    <!-- <form class="display-block" [formGroup]="ccForm" fxFlex="100%">
                                <div fxFlex="100%" fxLayout="row wrap" fxLayout.xs="column" fxLayoutGap="15px grid">                           
                                    <div fxFlex="33%" fxFlex.lg="33%" fxFlex.md="33%" fxFlex.sm="100%" fxFlex.xs="100%">
                                        <mat-form-field class="w-100">
                                            <mat-label>Name On Card</mat-label>
                                            <input type="text" matInput formControlName="nameOnCard" required>
                                            <mat-error *ngIf="ccForm.get('nameOnCard').hasError('required')">
                                                Please enter name on card
                                            </mat-error>
                                        </mat-form-field>
                                    </div>
                                    <div fxFlex="33%" fxFlex.lg="33%" fxFlex.md="33%" fxFlex.sm="100%" fxFlex.xs="100%">
                                        <mat-form-field class="w-100">
                                            <mat-label>Card number</mat-label>
                                            <input matInput allowValues isInputType="number" placeholder="9999 9999 9999 9999"
                                                formControlName="cardNumber" minlength="13" maxlength="16" required>
                                            <mat-error *ngIf="ccForm.get('cardNumber').hasError('required')">
                                                Please enter card number
                                            </mat-error>
                                            <mat-error *ngIf="ccForm.get('cardNumber').hasError('minlength')">
                                                Please enter valid card number
                                            </mat-error>
                                        </mat-form-field>
                                    </div>
                                    <div fxFlex="33%" fxFlex.lg="33%" fxFlex.md="33%" fxFlex.sm="100%" fxFlex.xs="100%">
                                        <mat-form-field class="w-100">
                                            <mat-label>Exp. date</mat-label>
                                            <input matInput placeholder="MM/YY" formControlName="expDate" mask="00/00"
                                                (blur)="formatMonth()" required>
                                            <mat-error *ngIf="ccForm.get('expDate').hasError('required')">
                                                Please enter expiry date
                                            </mat-error>
                                            <mat-error *ngIf="ccForm.get('expDate').hasError('Mask error')">
                                                Please enter expiry date in MM/YY format
                                            </mat-error>
                                        </mat-form-field>
                                    </div>
                                    <div fxFlex="33%" fxFlex.lg="33%" fxFlex.md="33%" fxFlex.sm="100%" fxFlex.xs="100%">
                                        <mat-form-field class="w-100">
                                            <mat-label>Cvv code</mat-label>
                                            <input matInput placeholder="000" minlength="3" maxlength="4" formControlName="cvv"
                                                type="password" allowValues isInputType="number" required>
                                            <mat-error *ngIf="ccForm.get('cvv').hasError('required')">
                                                Please enter CVV
                                            </mat-error>
                                            <mat-error
                                                *ngIf="ccForm.get('cvv').hasError('minlength') || ccForm.get('cvv').hasError('maxlength') || ccForm.get('cvv').hasError('pattern')">
                                                Please enter valid CVV
                                            </mat-error>
                                        </mat-form-field>
                                    </div>
                                </div>
                                <div fxLayout="row wrap" fxFlex="100%" class="mt-30">
                                    <button mat-flat-button class="square-btn" (click)="checkInfo(ccForm.valid)">Pay</button>
                                    <button fxShow.xs="true" fxHide mat-flat-button class="square-btn bgc-grey ml-20"
                                        (click)="redirectToHome()">Cancel</button> -->
                    <!-- <button mat-flat-button fxHide.xs="true" fxShow class="square-btn bgc-grey ml-20"
                                        (click)="closeModal()">Cancel</button>
                                </div>
                            </form> -->
                </div>

                <!-- <div *ngIf="getCurrency != 'USD'" class="mt-30">  19-10-2021 disabled paystand -->
                <form class="display-block" (ngSubmit)="makePayment()" class="checkout" [hidden]="selectedCard?.id">
                    <div id="form-field">
                        <div fxFlex="100%" class="text-center">
                            <div id="card-info" #cardInfo></div>
                            <mat-error id="card-errors" role="alert" *ngIf="cardError" class="mt-20 mb-30">
                                <mat-icon class="c-error">cancel
                                </mat-icon>
                                &nbsp;{{ cardError }}
                            </mat-error>
                            <div class="text-left checkbox fs-16 mb-15">
                                <mat-checkbox name="saveCard" class="fw-300 t_c_checkBox"
                                    [ngModelOptions]="{standalone: true}" [(ngModel)]="save_card"
                                    (change)="saveCard($event)">
                                </mat-checkbox>Save card for future payments
                            </div>
                            <button mat-flat-button class="flat-primary-button tertiary-bg-btn1" id="submit-button"
                                type="submit">Pay</button>
                            <!-- <button fxShow.xs="true" fxHide mat-flat-button class="square-btn bgc-grey ml-20"
                                                    (click)="redirectToHome()">Cancel</button> -->
                            <button mat-flat-button fxHide.xs="true" *ngIf="deviceData == 'web'" fxShow
                                class="flat-secondary-button ml-20" (click)="close(paymentType)">Cancel</button>
                        </div>

                    </div>
                </form>
                <div *ngIf="!showBillingForm && !addNewCard && selectedCard?.id" class="text-center mt-20">
                    <button mat-flat-button class="flat-primary-button" id="submit-button"
                        (click)="makePayment('card')">Pay</button>
                    <!-- <button fxShow.xs="true" fxHide mat-flat-button class="square-btn bgc-grey ml-20"
                                                    (click)="redirectToHome()">Cancel</button> -->
                    <button mat-flat-button fxHide.xs="true" *ngIf="deviceData == 'web'" fxShow
                        class="flat-secondary-button ml-20" (click)="close(paymentType)">Cancel</button>
                </div>
                <div class="text-center" [hidden]="(!isAgrees && paymentType == 'pay_per_view') || !paypalScript">
                    <hr>
                    <div id="paypal-button"></div>
                </div>
            </div>
        </div>
        <!-- </mat-tab>

        </mat-tab-group> -->

    </div>

    <div *ngIf="isPaymentSuccess" id="payment_success" fxLayout="row wrap" fxFlex="100%" class="payment-box mt-40">
        <div fxLayout="row wrap" fxFlex="100%" class="payment-detail">
            <div fxFlex="100%" fxLayoutAlign="center center" class="text-center text-white">
                Payment completed Successfully. Go to the application.
            </div>
            <div class="text-center mt-20" fxFlex="100%" fxLayoutAlign="center center">
                <a class="flat-primary-button primary-bg-button" target="_other" rel="nofollow" [href]="streamUrl">
                    Go To
                    {{streamInfo.stream_status == 'pending' || streamInfo.stream_status == 'progress' ? 'Stream'
                    :'VOD'}}
                </a>
            </div>
        </div>



    </div>
    <div *ngIf="paymentSuccess" id="payment_success" fxLayout="column" fxFlex="100%"
        class="ff fs-16 mt-10 text-center p-40 lh-24">
        Your payment is successful.
        <div *ngIf="paymentType == 'performer_tip' || paymentType == 'community_tip'">
            <ng-container *ngIf="groupName; else performerTip">
                Tip paid successfully for {{groupName}}
            </ng-container>
            <ng-template #performerTip>
                <ng-container *ngIf="performerInfo?.performer_name; else tipSuccess">
                    Tip paid successfully for {{performerInfo?.performer_name}}
                </ng-container>
                <ng-template #tipSuccess>
                    Tip paid successfully
                </ng-template>
            </ng-template>
        </div>
        <div *ngIf="paymentType == 'charity_donation'">
            Donation paid successfully for {{charityInfo?.charity_name}}
        </div>
        <div class="text-center">
            <button mat-flat-button class="flat-secondary-button mt-20 " (click)="close(paymentType)">Close</button>
        </div>
    </div>
</div>